(function(){
"use strict";

angular.module("swapick")
.factory('ObjectsService', ObjectsService);

function ObjectsService($cordovaCamera, $ionicPlatform, $rootScope,
    DataService, $q, $ionicModal, $timeout, $ionicHistory, $state ){
    var svc = {}

    svc.getCameraImage = (source="CAMERA")=>{
      console.log("camera image...")

        var options = {
          quality: 80,
          destinationType: Camera.DestinationType.DATA_URL,
          sourceType: Camera.PictureSourceType[source],
          allowEdit: true,
          encodingType: Camera.EncodingType.JPEG,
          //targetWidth: 100,
          //targetHeight: 100,
          popoverOptions: CameraPopoverOptions,
          saveToPhotoAlbum: false,
          correctOrientation:true
        };

        return $cordovaCamera
        .getPicture(options)
        .then((imageData) => {
          if(!imageData){
            return;
          }
          return "data:image/jpeg;base64," + imageData;;

        }, err => {
          console.error(err);
        });


    };

    svc.getGalleryImage = ()=>{
      console.log("gallery image...")
      //return $ionicPlatform.ready(() => {

        var options = {
          maximumImagesCount: 1,
          quality: 80
        };

        return $cordovaImagePicker.getPictures(options)
        .then(results => {
          if(!results.length){
            return;
          }
          return $cordovaFile.readAsDataURL("", results[0])
            .then(success => {
              return results[0];
            }, error => {
              console.error(error)
            });
        }, (error) => {
          console.error(error);
        });

      //});
    }


    svc.getCallbackMethod = (attr, query, isInitializing) => {
      return  function () {
        if(isInitializing){
          return [];
        }
        return DataService.baseAttributeValues
        .oneUrl(attr.chiave)
        .oneUrl("values")
        .get()
        .then(resp => {
          if(!query){ return resp}
          let found =  _.filter(resp, item => item.match(new RegExp(query, "i")))
          return query ? [query].concat(found)  : found;
        });
      }
    }

    svc.getModelToItem = (modelValue, attr) => {
      return function(){
        return modelValue;
      }
    }

    svc.getAutocompleteOptions = (attr) => {
      let suggest = term => DataService.baseAttributeValues
      .oneUrl(attr.chiave)
      .oneUrl("values")
      .get()
      .then(resp => {
        return _.map(
          _.filter(resp, item => item.indexOf(term)!==-1),
          item => ({label:item, value:item}));
      });

      return {
        suggest : suggest
      }
    };

    svc.getSelectOptions =  (attr) => {
      return _.map(
          attr.dimensione.split(","),
          item => item.trim()
      );
    }

    svc.calculateAttributes = (obj, categoriesData) => {
        if(!obj.categoria) { return[];}
        let category = categoriesData.categoriesById[obj.categoria][0];
        return _.filter(category.attributi, i=>i.form);
    }

    svc.getCategoriesForMondo = (mondo, categoriesData) => {
      if(!mondo){ return []}
      return categoriesData.categoriesByMondo[mondo];
    }

    svc.prepareServices = (services, objectId)  =>{
      let out = [];
      _.each(services, (v,k)=> {
        if(k && v){
          out.push({service:k, item:objectId})
        }
      })
      return out;
    }

    svc.enoughEcoins = (services, currentServices, newService, available) =>{
      let svcs = _.filter(services, i => currentServices[i])
      let  total = _.sum(_.map(svcs, s => s.costo))
      return available - total - newService.costo >= 0;
    }

    svc.shopServices = (services, packages) => {
      let out = $q.defer();
      console.log("async buy starts ........ => here!")
      //out.reject("www cannot buy yet")
      console.log(1, services)
      return $timeout(()=>{
        console.log("async buy ends ........ => here!")
        return true
      }, 100)
      .then(()=>{
        let promises = [];
        _.each(services, s => {
          promises.push(DataService.buyService.post(s))
        })
        return $q.all(promises);
      })
      .then(()=>{
        return DataService.ecoins
        .get()
        .then(resp => {
          $timeout(()=>{
            $rootScope.globals.userEcoins = parseInt(resp);
          });
        })
      })
      return out.promise;
    }


    svc.prepareObjectForSave = (obj, withAttributes=true) => {
      let out =  {
        id : obj.id,
        altre_immagini :  obj.altre_immagini.filter(item=>!item.percorso).map(({image}) => image),
        valore :  obj.valore,
        condizioni: obj.condizioni,
        descrizione: obj.descrizione
      }

      if(withAttributes){
        out.attributi = _.map( obj.attributi, (v,k)=>{
          let o = {}
          o[k] = v;
          return o;
        });

        out.titolo = obj.titolo;
        out.cat_id = obj.categoria;
        out.immagine =  obj.immagine;
      }
      return out;
    }

    svc.saveNewObjectToServer = (obj, userId) => {
      let outObj = svc.prepareObjectForSave(obj)
      console.log("saving", outObj);
      return DataService.items
      .post(outObj);
      /*
      .then(resp=>{
        console.log(resp);
        $ionicHistory.nextViewOptions({
          disableBack: true,
          historyRoot : true,
        });
        return $state.go("app.logged.object", {objectId:resp.id, userId:userId});
      })
      .catch(err=>{
        console.error(err);
      })
      */
    }

    svc.saveObjectToServer = (obj, userId) => {
      let outObj = svc.prepareObjectForSave(obj, false)
      console.log("saving", outObj);
      return DataService.owned
      .all(outObj.id)
      .patch(outObj)
      /*
      .then(resp=>{
        console.log(resp);
        $ionicHistory.nextViewOptions({
          disableBack: true,
          historyRoot : true,
        });
        return $state.go("app.logged.object", {objectId:resp.id, userId:userId});
      })
      .catch(err=>{
        console.error(err);
      })
      */
    }

    svc.saveNewInterestToServer = (obj, userId) => {
      let outObj = svc.prepareObjectForSave(obj)
      console.log("saving interest", outObj);
      return DataService.interests
      .post(outObj);
      /*
      .then(resp=>{
        console.log(resp);
        $ionicHistory.nextViewOptions({
          disableBack: true,
          historyRoot : true,
        });
        return $state.go("app.logged.object", {objectId:resp.id, userId:userId});
      })
      .catch(err=>{
        console.error(err);
      })
      */
    }




    return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/objects-service.js